import { render, staticRenderFns } from "./repru-leistung-freigabe-modal.vue?vue&type=template&id=1f6a5f6c&scoped=true"
import script from "./repru-leistung-freigabe-modal.vue?vue&type=script&lang=js"
export * from "./repru-leistung-freigabe-modal.vue?vue&type=script&lang=js"
import style0 from "./repru-leistung-freigabe-modal.vue?vue&type=style&index=0&id=1f6a5f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6a5f6c",
  null
  
)

export default component.exports